import type { RawPriceItemType } from 'core/accounting/infra/PriceItemTypeMapper'
import type { StopType } from 'core/domain/Stop'

import type { AccessorialHistoryCharge } from '../domain/QuoteAccessorial'
import type { RawQuoteAccessorial } from './SpotQuoteMapper'

export type RawAccessorialHistoryCharge = {
  accessorial?: RawQuoteAccessorial
  price_item_type?: RawPriceItemType
  stop_type?: StopType
  price: string
  unit: string
  note: string
}

export function mapApiToAccessorialHistoryCharges(
  historyCharges: Array<RawAccessorialHistoryCharge>
): Array<AccessorialHistoryCharge> {
  return historyCharges.map(historyCharge => {
    return {
      rate: Number(historyCharge.price),
      unit: historyCharge.unit,
      notes: historyCharge.note,
      accessorial: historyCharge.accessorial
        ? {
            code: historyCharge.accessorial.code,
            name: historyCharge.accessorial.name,
            stopType: historyCharge.accessorial.stop_type,
            modes: historyCharge.accessorial.modes,
          }
        : undefined,
      priceItemType: historyCharge.price_item_type
        ? {
            uuid: historyCharge.price_item_type.uuid,
            label: historyCharge.price_item_type.label,
          }
        : undefined,
      stopType: historyCharge.stop_type,
    }
  })
}
